'use strict';

var ChatUtils = require('../ChatUtils');
var TeamUtils = require('../TeamUtils');
var FirebaseUtils = require('../FirebaseUtils');

var RemoveUsersFromTeam = {
  getSchema: function getSchema() {
    return {
      "definitions": {
        "team": {
          "type": "object",
          "properties": {
            "id": { "type": "string" }
          },
          "required": ["id"]
        },
        "members": {
          "items": {
            "type": "object",
            "properties": {
              "userId": { "type": "string" },
              "access": { "type": "string" }
            },
            "required": ["userId", "access"]
          }
        }
      },

      "properties": {
        "team": { "$ref": "#/definitions/team" },
        "members": { "$ref": "#/definitions/members" }
      },
      "required": ["team", "members"]
    };
  },

  execute: function execute(fbApp, body, timestamp, callback) {
    var updates = {};
    var dbRef = fbApp.database().ref();

    // Get rooms for this team
    var rooms = [];
    dbRef.child('teams/' + body.team.id + '/rooms').once('value').then(function (snapshots) {
      snapshots.forEach(function (room) {
        rooms.push(room.key);
      });

      // For every member
      body.members.forEach(function (member) {

        // Unlink from every room
        rooms.forEach(function (roomId) {
          return ChatUtils.removeUserFromRoom(updates, timestamp, { id: roomId }, body.team, member);
        });

        // Unlink from teamId
        TeamUtils.removeUserFromTeam(updates, timestamp, body.team, member);

        // If still invitee, remove from invites
        if (member.access === "invitee") {
          TeamUtils.deleteTeamInvite(updates, timestamp, body.team, { id: member.userId });
        }
      });

      console.log('Updates', updates);

      // Save to firebase
      FirebaseUtils.saveToFirebase(dbRef, updates, callback);
    }).catch(function (error) {
      console.log('Error running script', error);
      callback({ errorMessage: error });
    });
  }
};

module.exports = RemoveUsersFromTeam;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/functions/RemoveUsersFromTeam.js
// module id = 1037
// module chunks = 0